<script>
	import configuration from '../configuration.json';
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';
    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';

    import Section from '../components/Section.svelte';
    import Status from '../components/Status.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';

    const current = 'failure';

    function tryAgain() {
        // Clear appointment data and go back to schedule
        currentSession.date = null;
        currentSession.time = null;

        replace('schedule', 'left');
    }

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('failure')}</title>
</svelte:head>

<Section title={$_('failure')}>
    <Status icon="failed">
        {$_('appointment_failed')}
    </Status>

    <p>
        {$_('appointment_conflict')}
    </p>

    <Navigation>
        <Button color="accent" onclick={tryAgain}>
            {$_('try_again')}
            <Icon data={arrowRightIcon} />
        </Button>
    </Navigation>
</Section>